/**
 * @generated SignedSource<<bfaf9e25241bf8b05042a77719b4b52d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNoteInput = {
  clientMutationId?: string | null;
  noteId: string;
};
export type DeleteNoteModalDeleteNoteMutation$variables = {
  input: DeleteNoteInput;
};
export type DeleteNoteModalDeleteNoteMutation$data = {
  readonly deleteNote: {
    readonly clientMutationId: string | null;
    readonly noteId: string | null;
    readonly ok: boolean;
  } | null;
};
export type DeleteNoteModalDeleteNoteMutation = {
  response: DeleteNoteModalDeleteNoteMutation$data;
  variables: DeleteNoteModalDeleteNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteNotePayload",
    "kind": "LinkedField",
    "name": "deleteNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noteId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNoteModalDeleteNoteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNoteModalDeleteNoteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "426ac9ea7984f93018c5125e376caad2",
    "id": null,
    "metadata": {},
    "name": "DeleteNoteModalDeleteNoteMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNoteModalDeleteNoteMutation(\n  $input: DeleteNoteInput!\n) {\n  deleteNote(input: $input) {\n    clientMutationId\n    ok\n    noteId\n  }\n}\n"
  }
};
})();

(node as any).hash = "df071ad1046122ab23baf12e074f4463";

export default node;
